import { buildPath } from "./buildPath";

export const circleAiOfferHumanSupport = {
  create: () => buildPath("/internal_api/circle_ai/offer_human_support"),
};
